import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServiceCategoriesBusinessService } from 'projects/Administration/src/app/business-services/service-categories-business.service';
import { Constant } from './../../../../../../../Autofacets-Core/src/app/utils/constant';
import { TranslateService } from '@ngx-translate/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageService } from 'projects/Administration/src/app/services/image.service';

@Component({
  selector: 'app-add-service-category',
  templateUrl: './add-service-category.component.html',
  styleUrls: ['./add-service-category.component.css']
})
export class AddServiceCategoryComponent implements OnInit {

  addServiceCategories = false;
  addServiceCategoriesForm: FormGroup;
  logoClass:string = '';
  Language: any[];
  OrderNumber: number;
  image: string | ArrayBuffer;
  imageBaseData: string | ArrayBuffer = null;

  constructor(private formBuilder: FormBuilder,
    private serviceCategoriesService: ServiceCategoriesBusinessService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private activeModal : NgbActiveModal,
    private imageService:ImageService
  ) { }

  ngOnInit(): void {
    this.Language = this.currentLanguageService.LanguageList;
    this.addServiceCategoriesForm = this.formBuilder.group({
      service: new FormArray([]),
      Image: [''],
      ImageBinaryData: [''],
      MimeType: [''],
      OrderNumber:[null,[Validators.pattern("[0-9]+")]], 
    });
    this.getLanguage();
  }

  get cpf() {
    return this.addServiceCategoriesForm.controls;
  }

  get t() { return this.cpf.service as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',Validators.required],
                name: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}


  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.addServiceCategoriesForm.controls["MimeType"].setValue(files[0].type);
    this.addServiceCategoriesForm.controls["Image"].setValue(files[0].name);
    let imageSize = files[0].size;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat=this.imageService.validateImageFormat(this.addServiceCategoriesForm.value.MimeType);
    if(isValidFormat)
    {
      if(imageSize < 100000)
      {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.addServiceCategoriesForm.controls["ImageBinaryData"].setValue(reader.result.toString().replace('data:' + this.addServiceCategoriesForm.value.MimeType + ';base64,', ''));
        this.image = me.imageBaseData;
        };
      }
      else
      {
        let errormsg = this.translate.instant("lblSizeExceedError");
        this.toastr.error(errormsg);
      }
     }
    reader.onerror = function (_error) {
       // This is intentional
    };

  }

  RemoveLogo(){
    this.addServiceCategoriesForm.value.Image = "";
    this.addServiceCategoriesForm.value.ImageBinaryData = "";
    this.image = "";
  }


  onSubmit() {
    this.addServiceCategories = true;
    if (this.addServiceCategoriesForm.invalid) {
      return;
    }
    let viewModal = {
      LanguageDetails: this.addServiceCategoriesForm.value.service,
      Image: this.addServiceCategoriesForm.value.Image,
      ImageBinaryData: this.addServiceCategoriesForm.value.ImageBinaryData,
      MimeType: this.addServiceCategoriesForm.value.MimeType,
      OrderNumber: this.addServiceCategoriesForm.value.OrderNumber,
      Id:0
    }
    this.spinner.show();
    this.serviceCategoriesService.addUpdateServiceCategories(viewModal).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        let successmsg = this.translate.instant("lblAddedServiceCategory");
        this.toastr.success(successmsg);
        this.spinner.hide();
        this.activeModal.close({ success: true });
      }
      else if(response.responseCode == Constant.ResponseCode)
      {
        let errormsg = this.translate.instant("lblAlreadyAddedServiceCategory");
        this.toastr.error(errormsg);
      }
      this.spinner.hide();
    });
   }
   OnClose(){
    this.activeModal.close({success:false})
  }
}
